import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  FaChevronDown,
  FaCloud,
  FaShieldAlt,
  FaMicrosoft,
} from "react-icons/fa";
import "./HostedTeams.css";

export default function HostedTeams(): JSX.Element {
  const [open, setOpen] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpen(open === i ? null : i);
  };

  const renderAccordionContent = (index: number): JSX.Element | null => {
    switch (index) {
      case 0:
        return (
          <div className="teams-table">
            <table>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Unit</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Teams Calling PAYG / Resource Account</td>
                  <td>Monthly</td>
                  <td>$20.00</td>
                </tr>
                <tr>
                  <td>Teams Calling Value / Resource Account</td>
                  <td>Monthly</td>
                  <td>$45.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        );

      case 1:
        return (
          <div className="teams-table">
            <table>
              <thead>
                <tr>
                  <th>Destination</th>
                  <th>Unit Type</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Local</td>
                  <td>Per Minute</td>
                  <td>$0.0000</td>
                </tr>
                <tr>
                  <td>National</td>
                  <td>Per Minute</td>
                  <td>$0.0000</td>
                </tr>
                <tr>
                  <td>13/1300</td>
                  <td>Per Call</td>
                  <td>$0.4500</td>
                </tr>
                <tr>
                  <td>Mobile</td>
                  <td>Per Minute</td>
                  <td>$0.0000</td>
                </tr>
                <tr>
                  <td>1800 Included</td>
                  <td>Per Call</td>
                  <td>$0.0000</td>
                </tr>
              </tbody>
            </table>
          </div>
        );

      case 2:
        return (
          <div className="teams-table">
            <table>
              <thead>
                <tr>
                  <th>Destination</th>
                  <th>Unit Type</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Local</td>
                  <td>Per Minute</td>
                  <td>$0.2200</td>
                </tr>
                <tr>
                  <td>National</td>
                  <td>Per Minute</td>
                  <td>$0.2200</td>
                </tr>
                <tr>
                  <td>13/1300</td>
                  <td>Per Call</td>
                  <td>$0.4500</td>
                </tr>
                <tr>
                  <td>Mobile</td>
                  <td>Per Minute</td>
                  <td>$0.4500</td>
                </tr>
                <tr>
                  <td>1800 Included</td>
                  <td>Per Call</td>
                  <td>$0.0000</td>
                </tr>
              </tbody>
            </table>
          </div>
        );

      case 3:
        return (
          <div className="teams-table">
            <table>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Unit Type</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1 GEO DID</td>
                  <td>Per Single</td>
                  <td>$5.00</td>
                </tr>
                <tr>
                  <td>10 GEO DID</td>
                  <td>Per 10 Block</td>
                  <td>$25.00</td>
                </tr>
                <tr>
                  <td>100 GEO DID</td>
                  <td>Per 100 Block</td>
                  <td>$50.00</td>
                </tr>
                <tr>
                  <td>Business SIP Trunk Access Activation Fee</td>
                  <td>Per Channel</td>
                  <td>$99.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        );

      // 4 - Notes
        case 4:
        return (
            <div className="teams-acc-notes">
            <ol>
                <li>All pricing are inc. GST.</li>
                <li>Timed calls are billed per second increments.</li>
                <li>Your choice of Teams calling model will be applied at customer level.</li>
                <li>Fair use policy applies.</li>
                <li>
                Unite Calling does not include required Microsoft Licences; please ensure
                your customer has required licences to use this product.
                </li>
            </ol>
            </div>
        );

      default:
        return null;
    }
  };

  const accordionTitles = [
    "Teams Direct Routing - Access Charges",
    "Calling Rates - VALUE",
    "Calling Rates - PAYG",
    "Other Charges",
    "Notes",
  ];

  return (
    <motion.main
      className="teams-page"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
    >
      {/* HERO */}
      <section className="teams-hero">
        <h1>J-Voice Microsoft Teams</h1>
        <p>
          Cloud-powered calling inside Microsoft Teams - simple, secure,
          reliable, and ready for modern Australian workplaces.
        </p>
      </section>

      {/* MAIN CONTENT */}
      <div className="teams-flex-row">
        <div className="teams-plans">
          {/* VALUE PLAN */}
          <motion.div
            className="teams-plan-card popular"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h3>PREMIUM</h3>

            <h4 className="section-title">Best for</h4>
            <ul>
              <li> Teams-first offices with predictable usage</li>
              <li> Users on Teams desktop and mobile apps</li>
            </ul>

            <h4 className="section-title">Includes</h4>
            <ul>
              <li> Local calls</li>
              <li> National calls</li>
              <li> Mobile calls</li>
              <li> 13/1300 calls</li>
            </ul>

            <h4 className="section-title">Support</h4>
            <ul>
              <li> Business-grade support from Jortel</li>
            </ul>

            <div className="price-area">
              <div className="price-tag">$45</div>
              <span className="unit">/ licence / month</span>
            </div>
            <a
              className="teams-cis"
              href="/docs/Jortel%20Teams%20Calling%20Critical%20Information%20Summary.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Critical Information Summary
            </a>
          </motion.div>

          {/* PAYG PLAN - UPDATED WITH EXTRA DOTPOINTS */}
          <motion.div
            className="teams-plan-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3>PAYG</h3>

            <h4 className="section-title">Best for</h4>
            <ul>
              <li> Low or variable call volumes</li>
              <li> Seasonal or part-time Teams users</li>
            </ul>

            <h4 className="section-title">Included</h4>
            <ul>
              <li> Included call bundles</li>
              <li> Access to Jortel's per-minute rates</li>
              <li> No mobile call bundles</li>
              <li> No 13/1300 inclusions</li>
            </ul>

            <h4 className="section-title">Support</h4>
            <ul>
              <li> Business-grade support from Jortel</li>
            </ul>

            <div className="price-area">
              <div className="price-tag">$20</div>
              <span className="unit">/ licence / month</span>
            </div>
            <a
              className="teams-cis"
              href="/docs/Jortel%20Teams%20Calling%20PAYG%20Critical%20Information%20Summary.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Critical Information Summary
            </a>
          </motion.div>
        </div>

        {/* RIGHT SIDEBAR BOX */}
        <motion.div
          className="teams-dropdown-box"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <div className="teams-dropdowns">
            {accordionTitles.map((title, i) => (
              <div
                key={i}
                className={`teams-acc-item ${open === i ? "open" : ""}`}
              >
                <div className="teams-acc-header" onClick={() => toggle(i)}>
                  <span>{title}</span>
                  <FaChevronDown className="chevron" />
                </div>
                <div className="teams-acc-body">
                  {renderAccordionContent(i)}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* BENEFITS SECTION */}
      <section className="teams-benefits">
        <h2>Why run your phone system in Microsoft Teams?</h2>

        <div className="teams-benefits-grid">
          <motion.div
            className="teams-benefit-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            <FaMicrosoft className="benefit-icon" />
            <h3>One App for Everything</h3>
            <p>
              Chat, meetings and external calls all inside Teams - no extra apps
              or softphones needed.
            </p>
          </motion.div>

          <motion.div
            className="teams-benefit-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.05 }}
          >
            <FaCloud className="benefit-icon" />
            <h3>No On-Prem PBX</h3>
            <p>
              Retire legacy phone systems and direct dial straight into your
              Microsoft 365 tenant.
            </p>
          </motion.div>

          <motion.div
            className="teams-benefit-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            <FaShieldAlt className="benefit-icon" />
            <h3>Carrier-Grade Reliability</h3>
            <p>
              Jortel's network delivers enterprise-grade call quality &
              resilience.
            </p>
          </motion.div>
        </div>
      </section>

      {/* CTA PANEL */}
      <section className="advisor-panel">
        <div className="advisor-content">
          <h2>Ready to bring calling into Microsoft Teams?</h2>
          <p>
            Our engineers can review your existing phone system, map users to
            Teams, and design a migration that minimises downtime while keeping
            costs predictable.
          </p>
          <a href="/contact" className="btn primary">
            Talk to the Jortel team
          </a>
        </div>
      </section>
    </motion.main>
  );
}

